/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
 

import React, { useEffect, useRef, useState } from "react";
import Sheet from "./Sheet.jsx";
import Toolbar from "./Toolbar.jsx";
import { nanoid } from "nanoid";
import "./PdfEditor.css";
import ClickAway from "./ClickAway.jsx";
import ContextMenu from "./ContextMenu.jsx";
import { createIntersectionObserver, deleteById, pageID } from "./utils.jsx";
import { Spinner } from "../CommonComponents.js";
import Canvas from "./Canvas.jsx";
import IFrame from "./IFrame.jsx";
import idb from "./idb.js";

const eventMap = {
  insertText: false,
  editingText: false,
  cancel: false,
};

function generateNewBlock(parentId, position, options = {}) {
  const { type = "text", id, focused = true } = options;
  return {
    id: parentId,
    content: {
      id: id ?? nanoid(7),
      insert: true,
      type,
      focused,
      data: "",
      position,
      style: {
        size: 16,
      },
    },
  };
}

function getInitialTemplate(template) {
  return template?.pages ? template : null;
}

function PdfEditorApp(props) {
  const { readOnly, template } = props;

  const [scale, setScale] = useState(1);
  const [data, setData] = useState(getInitialTemplate(template));
  const [insertText, setInsertText] = useState(null);
  const [isImageMode, setIsImageMode] = useState(false);

  const menuRef = useRef(null);
  const [showMenu, setShowMenu] = useState(false);
  const [currentPage, setCurrentPage] = useState({
    key: null,
    id: null,
    value: null,
  });
console.log(props.template,"template")
  useEffect(() => setData(props.template), [props.template]);

  function insertTextBox(data) {
    setInsertText(data);
  }

  function handleContextMenu(e, key) {
    const pageId = `sheet-id--${key}`;
    const pageNode = window.pdfDoc.getElementById(pageId);

    if (!pageNode.contains(e.target)) {
      return;
    }

    menuRef.current.style.display = "none";
    menuRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;

    setCurrentPage({
      key,
      id: pageId,
      value: +pageNode.attributes.dataindex.value,
    });
    setTimeout(() => {
      menuRef.current.style.display = "flex";
    }, [126]);

    setShowMenu(true);
  }

  async function handleInsertPage(offset) {
    const currentIndex = currentPage.value + offset;
    let existingData = await idb.reSyncFrom(data.id);
    const pageId = pageID(currentIndex, data.id);
  
    if (!existingData.pages[currentIndex]) {
      existingData.pages.splice(currentIndex, 0, {
        id: pageId,
        layout: "",
        content: [],
        action: "inserted",
      });
    }
  
    existingData.pages = existingData.pages.filter(d => d && d.action !== "deleted");
  
    // Update page IDs and assets
    for (let i = currentIndex + 1; i < existingData.pages.length; i++) {
      if (existingData.pages[i].action === "inserted") {
        existingData.pages[i].id = pageID(i, data.id);
      }
    }
  
    setData(existingData);
  }
  
  async function handleDeletePage(id) {
    const existingData = await idb.reSyncFrom(data.id);
    if (!existingData || !existingData.pages) return;
  
    existingData.pages = deleteById(currentPage.key, currentPage.value, existingData.pages).filter(
      (d) => d && d.action !== "deleted"
    );
  
    idb.assets.put(data.id, { action: "deleted", mutated: 1 }, currentPage.key);
    setData(existingData);
  }
  
  function handlePagination(entries, observer) {
    const page = entries.find((elem) => elem.intersectionRect.height / elem.rootBounds.height > 0.4);
    const pageIndex = +page?.target?.attributes?.dataindex?.value ?? 0;

    if (!(page && entries[pageIndex])) {
      return;
    }
    const key = entries[pageIndex].target.attributes.datakey.value;
    setCurrentPage({ id: key, value: pageIndex });
  }

  function handleScroll() {
    const target = window?.pdfDoc?.querySelectorAll?.(".pdf-sheet");
    const config = {
      root: window?.pdfDoc?.getElementById?.("pdf-sheet--cont"),
      threshold: 1.0,
    };
    createIntersectionObserver(target, config, handlePagination);
  }

  const [brush, setBrush] = useState({
    active: false,
    color: "#000",
    size: 2,
  });

  function handleBrushColor(color) {
    setBrush({ ...brush, color });
  }

  function handleBrushSelect() {
    setBrush({ ...brush, active: !brush.active });
  }

  async function handleImageChange(images) {
    let data_ = { ...data };
    for (let i = 0; i < images.length; i++) {
        const pageId = data_.pages[i].id;
        data_.pages[i].layout = images[i];

        await idb.assets.put(props.docId, { data: images[i], mutated: 1, action: "changed" }, pageId);
    }

    const dat = await idb.reSyncFrom(data.id);
    data_ = { ...dat, file_type: "pdf" };
  
    setData(data_); 

}


  function handleBrushSizeChange(size) {
    setBrush({ ...brush, size });
  }

  async function handleClose() {
    const timestamp = (await idb.metadata.get(props.docId, "metadata")).lastactiontime;
    props?.onClose?.(null, timestamp);
  }

  
  useEffect(() => {
    (async () => {
      console.log("MOUNT", props);
      const id = props.docId;
      const data_ = await idb.fetch(id);
      console.log(data_);
      data_['file_type']=props.type      // console.log(data_);
      if (!data_) props.onClose(true);
      // data_ = await idb.reSyncFrom(data_.id);
      // console.log(data_);
      setData(data_);
    })();
  }, [props.docId]);

  if (!data) {
    return;
  }

  return (
    <React.Fragment>
      <div className="pdf-main--cont">
        <Toolbar
          _key={currentPage.id}
          docId={props.docId}
          totalPage={data.pages.filter((d) => d.action !== "deleted").length}
          currentPage={currentPage.value}
          metaData={{
            id: data.id,
            name: data.name,
            size: data.size[0] + "px," + data.size[1] + "px",
            file_type:data.file_type
          }}
          isImageMode={isImageMode}
          onImageModeClick={() => setIsImageMode(!isImageMode)}
          brush={brush}
          onColorSelect={handleBrushColor}
          onBrushSelect={handleBrushSelect}
          onImageChange={handleImageChange}
          onBrushSizeChange={handleBrushSizeChange}
          onShowKeyboard={props?.onShowKeyboard}
          onSelectLang={props?.onSelectLang}
          onClose={handleClose}
          readOnly={readOnly}
          scaleValue={2}
          onScaleChange={setScale}
        />
         
        {!readOnly && (
          <ClickAway onClickAway={setShowMenu} sync={showMenu} boundClass={["pdf-sheet", "sheet-bg"]}>
            <ContextMenu
              _ref={(e) => {
                menuRef.current = e;
              }}
              pageId={currentPage.id}
              open={showMenu}
              totalPages={data.pages.length}
              insertText={({ id, position }) => {
                console.log("trigger");
                insertTextBox(generateNewBlock(id, position));
              }}
              onInsertPage={handleInsertPage}
              onDeletePage={handleDeletePage}
              setShowMenu={setShowMenu}
            />
          </ClickAway>
        )}

        <div id="pdf-sheet-main--cont" style={{ position: "relative", flexGrow: 1, overflow: "auto" }}>
          <div id="pdf-sheet--cont" style={{ ...props?.sheetStyle }} onScroll={handleScroll}>
            {data.pages
              .filter((d) => d.action !== "deleted")
              .map((d, idx) =>
                isImageMode ? (
                  <Canvas
                    key={d.id}
                    index={idx}
                    id={d.id}
                    data={d}
                    size={data.size}
                    style={{
                      width: `${data?.size?.[0]}px`,
                      height: `${data?.size?.[1]}px`,
                    }}
                    brush={brush}
                  />
                ) : (
                  <Sheet
                    key={d.id}
                    docId={props.docId}
                    index={idx}
                    id={d.id}
                    data={d}
                    insertText={insertText}
                    onContextMenu={handleContextMenu}
                    bg={d.layout}
                    readOnly={readOnly}
                    size={data.size}
                    style={{
                      width: `${data?.size?.[0]}px`,
                      height: `${data?.size?.[1]}px`,
                    }}
                    strict={!!props.strict}
                    scale={scale}
                  />
                )
              )}
          </div>

          <div id="overlay"></div>
        </div>

        <Spinner area={"download-pdf"} />
      </div>
    </React.Fragment>
  );
}

function PdfEditor(props) {
  console.log("PdfEditor.jsx props",props);
  return (
    <IFrame id="pdf-frame--cont" style={props.style}>
      <PdfEditorApp {...props} />
    </IFrame>
  );
}

export default PdfEditor;
